import { createFileRoute } from '@tanstack/react-router';

import { CitationCreate } from '@/module/Author/Citation/CitationCreate';

export const Route = createFileRoute(
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { translationId } = Route.useParams();

  return <CitationCreate publicationId={Number(translationId)} />;
}
